import PropTypes from 'prop-types';
import React from 'react';
import { IMAGE_CDN_URL } from '../../../utilities/imageCDN';

import FGBLabel from '../../Elements/FGBLabel/FGBLabel';
import SliderNav from '../../Elements/SliderNav/SliderNav';

import './PregnancyHeader.scss';

export default class PregnancyHeader extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * object of pregnancy week items
         * of three types current, next, prev
         */
        menuItems: PropTypes.shape({
            currentWeek: PropTypes.shape({
                contentUrl: PropTypes.string,
                description: PropTypes.string,
                title: PropTypes.string,
                weekNumber: PropTypes.number,
            }),
            nextWeek: PropTypes.shape({
                contentUrl: PropTypes.string,
                description: PropTypes.string,
                title: PropTypes.string,
                weekNumber: PropTypes.number,
            }),
            prevWeek: PropTypes.shape({
                contentUrl: PropTypes.string,
                description: PropTypes.string,
                title: PropTypes.string,
                weekNumber: PropTypes.number,
            }),
        }).isRequired,
    };

    filterData = (key) => {
        const value = this.props.menuItems[key] || {};
        const { contentUrl, weekNumber } = value;

        return {
            url: contentUrl,
            title: weekNumber ? `Week ${weekNumber}` : '',
            isActive: key === 'currentWeek',
        };
    };

    renderStaticHeader = () => {
        return (
            <div className="header-section">
                <img
                    src={`${IMAGE_CDN_URL}/v1573750666/SVGs/pregnancy_header.svg`}
                    alt="meditating-women"
                />
                <FGBLabel>
                    <a href="/pregnancy-week-by-week">Pregnancy Week by Week</a>
                </FGBLabel>
            </div>
        );
    };

    renderSliderNav = () => {
        const condensedItems = Object.keys(this.props.menuItems).map(
            this.filterData
        );
        const [currentWeek, prevWeek, nextWeek] = condensedItems;

        return <SliderNav menuItems={[prevWeek, currentWeek, nextWeek]} />;
    };

    render() {
        return (
            <div className="component-Resources-PregnancyHeader">
                {this.renderStaticHeader()}
                {this.renderSliderNav()}
            </div>
        );
    }
}
